module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _vm._c('div', [_vm._c('PageHeader', {
    attrs: {
      "title": "Micro Notes"
    }
  }), _vm._v(" "), _vm._c('div', {
    staticClass: "main-content container-fluid"
  }, [_vm._c('div', {
    staticClass: "row"
  }, [_vm._c('div', {
    staticClass: "col-md-12"
  }, [_vm._c('Panel', {
    staticClass: "panel panel-default panel-border-color panel-border-color-primary"
  }, [_vm._c('PanelBody', [_vm._c('code', [_vm._v("#todo - list of micro notes for chapter X? not sure actually let's discuss first. page may not be needed")])])], 1)], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-07665028!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/micro-note-list/MicroNoteList.vue
// module id = 616
// module chunks = 1